module.exports = __webpack_public_path__ + "static/img/suv-red.af2276d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/suv-red.svg
// module id = PbPk
// module chunks = 74